<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer000">
<p class="ORIM-Blockquote-First-w-Hanging-Indent--Body- ParaOverride-1">A Faithful Record of Their Amazing Adventures</p>
<p class="ORIM-Blockquote-Body--Body- ParaOverride-1">in an Underground World; and How with the</p>
<p class="ORIM-Blockquote-Body--Body- ParaOverride-1">Aid of Their Friends Zeb Hugson, Eureka</p>
<p class="ORIM-Blockquote-Body--Body- ParaOverride-1">the Kitten, and Jim the Cab-Horse,</p>
<p class="ORIM-Blockquote-Body--Body- ParaOverride-1">They Finally Reached the</p>
<p class="ORIM-Blockquote-Body--Body- ParaOverride-1">Wonderful Land</p>
<p class="ORIM-Blockquote-Body--Body- ParaOverride-1">of Oz<a id="_idTextAnchor001"></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraph.vue?2c2b6d72